import courseService from '@/services/course';
import url from '@/lib/api/url';
import {throttle} from 'lodash';

const state = {
  video: null,
  version: null,
  languages: null,
  coursePlanId: null,
  day: null,
  language: null,
  token: null,
  questions: [],
};

const getters = {
  videoSrc(state) {
    const video = state?.video;
    const s3key = video?.s3key;
    if (s3key && state.coursePlanId && state.day && state.language) {
      const apiHost = url.apiHost;
      const encodedS3key = encodeURIComponent(s3key);
      const encodedToken = encodeURIComponent(state.token);
      return `${apiHost}hjjCourse/course-video/course/${state.coursePlanId}/day/${state.day}/m3u8/${state.language}?key=${encodedS3key}&token=${encodedToken}`;
    }
    return '';
  },
  subtitleUrls(state) {
    const video = state?.video;
    const subtitle = video?.subtitle;
    if (subtitle && state.coursePlanId && state.day && state.language) {
      const apiHost = url.apiHost;
      return `${apiHost}hjjCourse/course-video/course/${state.coursePlanId}/day/${state.day}/subtitle/${state.language}`;
    }
    return '';
  },
  coverUrls(state) {
    const video = state?.video;
    const cover = video?.cover;
    if (cover && state.coursePlanId && state.day && state.language) {
      const apiHost = url.apiHost;
      return `${apiHost}hjjCourse/course-video/course/${state.coursePlanId}/day/${state.day}/cover/${state.language}`;
    }
    return '';
  },
};

const actions = {
  async getCourseVideo({commit}, {coursePlanId, day, language}) {
    commit('setToken');
    commit('setCourseVideoParams');
    commit('setCourseVideoData');
    commit('setQuestions');
    const response = await courseService.getCourseVideo({
      coursePlanId,
      day,
      language,
    });
    const {video, version, languages} = response;
    if (video) {
      const response = await courseService.getCourseVideoToken({
        coursePlanId,
        day,
        language,
      });
      commit('setToken', {token: response.token});
    }

    commit('setCourseVideoParams', {coursePlanId, day, language});
    commit('setQuestions', {questions: video?.contents || []});
    commit('setCourseVideoData', {video, version, languages});
    return {video, version, languages};
  },
};

const throttleResetQuestions = throttle(async (state) => {
  state.questions = state.questions.map((q) => {
    return {
      ...q,
      isAnswered: false,
    };
  });
}, 500);

const mutations = {
  setToken(state, {token = null} = {}) {
    state.token = token;
  },
  setCourseVideoParams(
    state,
    {coursePlanId = null, day = null, language = null} = {}
  ) {
    state.coursePlanId = coursePlanId;
    state.day = day;
    state.language = language;
  },
  setCourseVideoData(
    state,
    {video = null, version = null, languages = null} = {}
  ) {
    state.video = video;
    state.version = version;
    state.languages = languages;
  },

  setQuestions(state, {questions = []} = {}) {
    state.questions = questions;
  },
  setQuestionIsAnswered(state, {questionId = null} = {}) {
    state.questions = state.questions.map((q) => {
      const isAnswered = q.id === questionId ? true : q.isAnswered;
      return {
        ...q,
        isAnswered,
      };
    });
  },
  resetQuestions(state) {
    throttleResetQuestions(state);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
